/* 數字模板 ---> 掛單搜尋取餐號 / 電話 / 外送平台取餐號 */
<template>
  <cus-dialog-in-dialog>
    <template v-slot:body>
      <div class="computer">
        <!-- 顯示欄位 -->
        <div class="compute-number">
          <p class="result">{{ computeNum }}</p>
        </div>
        <!-- 數字鍵 -->
        <div class="number-button">
          <cus-button v-for="num in 9" :key="num" :text="num.toString()" @click="handleNumber(num)"></cus-button>
          <cus-button text="0" style="grid-area: 4/1/5/3" @click="handleNumber(0)"></cus-button>
          <cus-button
            topIcon="arrow-left"
            topIconClass="back-arrow"
            :disabled="computeNum === '' || computeNum.length === cusProps.least"
            @click="handleBack"
          ></cus-button>
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <div class="d-flex">
        <cus-button text="取消" color="white" :width="50" @click="close"></cus-button>
        <cus-button
          text="確定"
          color="blue"
          :width="50"
          @click="submit(computeNum)"
          :disabled="computeNum === '' || computeNum.length < cusProps.disableMin"
        ></cus-button>
      </div>
    </template>
  </cus-dialog-in-dialog>
</template>
<script>
import { ref, inject, watch } from 'vue';
export default {
  name: 'string-number-input',
  setup() {
    //接受provide值
    const dialogVisible = inject('inner_dialogVisible', false);
    const name = inject('inner_name');
    const close = inject('inner_close');
    const submit = inject('inner_submit');
    const { cusProps } = inject('inner_cusProps');
    //設定參數
    const computeNum = ref(''); //顯示數值
    //設定初始值
    if (dialogVisible) {
      if (cusProps.init) computeNum.value = JSON.parse(JSON.stringify(cusProps.init));
    }
    //恢復初始值
    watch(dialogVisible, () => {
      computeNum.value = '';
    });
    //按數字
    const handleNumber = (num) => {
      if (computeNum.value.toString().length === cusProps.limit) return;
      computeNum.value = computeNum.value.toString() + num;
    };
    //消除數字
    const handleBack = () => {
      if (computeNum.value.length === 1) {
        computeNum.value = '';
      } else {
        computeNum.value = computeNum.value.toString().slice(0, -1);
      }
    };
    return {
      close,
      name,
      submit,
      cusProps,
      computeNum,
      handleNumber,
      handleBack,
    };
  },
};
</script>
<style lang="scss" scoped>
.computer {
  @include computer-basic;
  .result {
    color: $color-green;
  }
}
</style>
